<template>
  <div class="loginPage formStyle">
    <div class="back" v-if="!isLoginBox" @click="isLoginBox = true">
      <van-icon name="arrow-left" />
    </div>
    <div class="loginMain">
      <!-- <div class="loginLogo">
        <img class="logo" src="../../assets/img/logo.png" />
      </div> -->
      <!-- <div class="loginTitle">Smart Sketcher AI</div> -->
      <img class="loginLogo2" src="@/assets/img/logo_tate.svg" alt="" />
      <div class="loginForm">
        <van-form @submit="onSubmit" class="loginFormBox" v-if="isLoginBox">
          <div>Email</div>
          <van-field
            v-model="form.email"
            class="fontStyle"
            placeholder="メールアドレス"
          />
          <div style="margin-top: 6px;">パスワード</div>
          <van-field
            v-model="form.password"
            maxlength="30"
            class="fontStyle"
            :type="passwordTypeLogin"
            placeholder="パスワード"
          >
            <template slot="right-icon">
              <span class="pwdSolts" @click="switchPasswordTypeLogin">
                <van-icon name="eye" v-if="passwordTypeLogin === 'password'" />
                <van-icon name="closed-eye" v-else />
              </span> </template
          ></van-field>
          <div class="forgetPwd" @click="isLoginBox = false">
            パスワードをお忘れですか？
          </div>
          <div class="agreeText">
            <van-checkbox
              v-model="checked"
              @change="changeAgree"
            ></van-checkbox>
            <div>
              <span @click="$router.push({ path: `/userAgreement` })"
                >利用規約、著作権、およびプライバシーポリシー</span
              >を十分に理解し、同意する
            </div>
          </div>
          <div>
            <van-button
              style="margin-top: 0;"
              round
              block
              :loading="loading"
              type="info"
              native-type="submit"
              class="buttonBlue"
              >ログイン</van-button
            >
          </div>
        </van-form>
        <van-form class="loginFormBox" v-if="!isLoginBox">
          <div>Email</div>
          <van-field
            class="fontStyle"
            @change="changInput"
            v-model="forget.email"
            placeholder="メールアドレスを入力してください"
          />
          <div style="margin-top: 6px;">新しいパスワード</div>
          <van-field
            class="fontStyle"
            @change="changInput"
            v-model="forget.password"
            maxlength="12"
            :type="passwordType"
            placeholder="新しいパスワードを入力してください"
          >
            <template slot="right-icon">
              <span class="pwdSolts" @click="switchPasswordType">
                <van-icon name="eye" v-if="passwordType === 'password'" />
                <van-icon name="closed-eye" v-else />
              </span>
            </template>
          </van-field>
          <div class="pwdTips">
            ８文字以上12文字以内の半角英数字、１個以上の大文字必須
          </div>
          <div class="button">
            <van-button
              :loading="loadingCode"
              class="sendCode buttonBlue"
              v-show="Verification"
              @click="sendCode"
              type="info"
            >
            認証コードを取得</van-button
            >
            <div class="sendCodeTimer buttonBlue" v-show="!Verification">
              <span>{{ timer }}</span
              >S
            </div>
          </div>
          <div style="margin-top: 6px;">認証コード</div>
          <div class="getCode">
            <van-field
              class="fontStyle"
              @input="changInput"
              v-model="forget.code"
              maxlength="4"
              placeholder="認証コードを入力してください"
            />
          </div>
          <div>
            <van-button
              round
              block
              :disabled="disabled"
              :loading="loading"
              type="info"
              @click="forgetPwd"
              native-type="submit"
              class="buttonBlue mtop20"
              >確認</van-button
            >
          </div>
          <!-- <div class="forgetPwd" @click="isLoginBox = true">
            ログイン＃ログイン＃
          </div> -->
        </van-form>
      </div>
    </div>
    <van-popup v-model="goLoginPopup" closeable>
      <div class="content">
        <div>パスワード変更しました！</div>
        <div>ログインしましょう</div>
      </div>
      <div class="buttonItem">
        <div
          class="button cancel"
          @click="
            goLoginPopup = false;
            cancelForgetModel();
          "
        >
          閉じる
        </div>
        <div class="button sure" @click="sucGoLogin">
          ログイン
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";
import { Icon } from "vant";

Vue.use(Icon);
Vue.use(Toast);
import { login, forgetPassword, sendEmailCode } from "@/http/user";
import md5 from "js-md5";

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      forget: {
        email: "",
        password: "",
        code: ""
      },
      checked: false,
      timer: 300, // 定义初始时间为60s
      Verification: true, // 通过v-show控制显示获取还是倒计时
      resendCode: false,
      isLoginBox: true,
      disabled: true,
      goLoginPopup: false,
      loading: false,
      loadingCode: false,
      passwordTypeLogin: "password",
      passwordType: "password"
    };
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    switchPasswordTypeLogin() {
      this.passwordTypeLogin =
        this.passwordTypeLogin === "password" ? "text" : "password";
    },
    changeAgree(e) {
      // console.log("changeAgree", e);
    },
    onSubmit(values) {
      if (!this.form.email || this.form.email == "") {
        Toast({
          type: "fail",
          icon: "cross",
          message: "メールアドレスを入力してください"
        });
        return;
      }
      if (!this.form.password || this.form.password == "") {
        Toast({
          type: "fail",
          icon: "cross",
          message: "パスワード"
        });
        return;
      }
      if (this.checked) {
        this.loading = true;
        let params = {
          mailbox: this.form.email,
          password: md5(this.form.password)
        };
        login(params).then(res => {
          let { data, code } = res.data;
          if (code == 200) {
            Toast({
              type: "success",
              message: "ログインしました"
            });
            this.loading = false;
            setTimeout(() => {
              localStorage.setItem("token", data.accessToken);
              localStorage.setItem("userId", data.userId);
              this.$router.push({ path: `/` });
            }, 2000);
          } else {
            Toast({
              type: "fail",
              icon: "cross",
              message: res.data.msg
            });
            this.loading = false;
          }
        });
      } else {
        Toast({
          type: "fail",
          message:
            "利用規約、著作権、およびプライバシーポリシーへの同意が必要です"
        });
      }
    },

    sendCode() {
      if (!this.forget.email || this.forget.email == "") {
        Toast({
          type: "fail",
          icon: "cross",
          // duration: 0,
          message: "メールアドレスを入力してください"
        });
        return;
      }
      let email = /^[a-zA-Z0-9_.,*/;':<>~`#$%^&()=+-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
      if (!email.test(this.forget.email)) {
        Toast({
          type: "fail",
          icon: "cross",
          // duration: 0,
          message: "正しいメールアドレスを入力してください"
        });
        return;
      }
      this.loadingCode = true;
      let params = {
        mailbox: this.forget.email,
        type: 1
      };
      sendEmailCode(params).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            // duration: 0,
            message: "メールに認証コードを送信しました。"
          });
          this.clearInterval();
        } else {
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
        }
        this.loadingCode = false;
      });
    },
    clearInterval() {
      this.Verification = false; // 点击button改变v-show的状态
      let authTimer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.Verification = true; // 60s时间结束还原v-show状态并清除定时器
          this.resendCode = true;
          clearInterval(authTimer);
        }
      }, 1000);
      this.timer = 299;
    },
    changInput() {
      if (
        this.forget.email != "" &&
        this.forget.password != "" &&
        this.forget.code.length == 4
      ) {
        this.disabled = false;
      }
    },
    forgetPwd(values) {
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,12}$/;
      if (!reg.test(this.forget.password)) {
        Toast({
          type: "fail",
          icon: "cross",
          message: "8文字以上12文字以内の半角英数字、１個以上の大文字必須"
        });
        return;
      }
      this.loading = true;
      let params = {
        mailbox: this.forget.email,
        password: md5(this.forget.password),
        code: this.forget.code
      };
      forgetPassword(params).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.goLoginPopup = true;
          Toast({
            type: "success",
            message: "パスワード変更しました"
          });
        } else {
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
        }

        this.loading = false;
      });
    },
    cancelForgetModel() {
      this.forget.email = "";
      this.forget.password = "";
      this.forget.code = "";
      this.form.email = "";
      this.form.password = "";
      this.Verification = true;
      this.timer = 300;
    },

    sucGoLogin() {
      this.form.email = this.forget.email;
      this.form.password = this.forget.password;
      this.isLoginBox = true;
      this.goLoginPopup = false;
      this.forget.email = "";
      this.forget.password = "";
      this.forget.code = "";
      this.Verification = true;
      this.timer = 300;
    }
  }
};
</script>

<style src="@/assets/css/form.css" scoped></style>
<style>
.loginPage {
  width: 100%;
  height: 100%;
  background: url("../../assets/img/bg_login.png") no-repeat top center;
  background-size: cover;
  position: relative;
  overflow-y: scroll;
}
.loginPage .back {
  position: absolute;
  top: 10px;
  left: 12px;
  z-index: 90;
  cursor: pointer;
}
.loginPage .back .van-icon.van-icon-arrow-left {
  font-size: 18px;
  color: #fff;
}
.loginPage .loginMain {
  padding-top: 50px;
}
.loginPage .loginLogo {
  width: 80px;
  height: 80px;
  margin: 0 auto 0 auto;
  border-radius: 50%;
  background: rgb(255, 255, 255, 0.6);
  /* 卡片投影 */
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0);
  line-height: 80px;
  font-size: 20px;
  text-align: center;
  color: #92c3f0;
  overflow: hidden;
}
.loginPage .loginLogo .logo {
  width: 100%;
}
.loginPage .loginTitle {
  font-family: MediumFont;
  font-size: 20px;
  font-weight: normal;
  line-height: 32px;
  text-align: center;
  margin: 5px 0 24px 0;
  color: #2b99ff;
}
.loginPage .loginLogo2 {
  width: 40%;
  margin: 0 auto 24px auto;
  display: block;
}
.loginPage .van-checkbox__icon .van-icon {
  line-height: 16px;
  font-size: 12px;
}
.loginPage .van-checkbox__icon .van-icon {
  width: 16px;
  height: 16px;
}
.fontStyle input {
  font-size: 14px;
  font-family: RegularFont;
}
.fontStyle input::input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-moz-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-moz-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-ms-input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.loginPage.formStyle .loginForm .buttonBlue.mtop20 {
  margin-top: 20px;
}
.loginPage.formStyle .loginForm .pwdTips {
  font-family: RegularFont;
  color: #9e9e9e;
  font-size: 14px;
}
#app .loginPage .loginForm .button {
  width: 100%;
  margin: 12px 0 16px 0;
}
#app .loginForm .button .buttonBlue {
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: center;
}
@media screen and (min-width: 1439px) {
  .loginPage .back {
    top: 10px; /* no*/
    left: 12px; /* no*/
  }
  .loginPage .back .van-icon.van-icon-arrow-left {
    font-size: 18px; /* no*/
  }
  .loginPage .loginLogo {
    width: 80px; /* no*/
    height: 80px; /* no*/
    line-height: 80px; /* no*/
  }
  .loginPage .loginTitle {
    font-size: 20px; /* no*/
  }
  #app .loginPage .buttonBlue {
    height: 48px; /* no*/
    line-height: 48px; /* no*/
    font-size: 16px; /* no*/
  }
  .loginPage .van-checkbox__icon .van-icon {
    width: 18px; /* no*/
    height: 18px; /* no*/
  }
  .loginPage .van-checkbox__icon .van-icon {
    line-height: 16px; /* no*/
    font-size: 14px; /* no*/
  }
  .fontStyle input {
    font-size: 14px; /* no*/
  }
  .fontStyle input::input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-webkit-input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-ms-input-placeholder {
    font-size: 14px; /* no*/
  }
  .loginPage.formStyle .loginForm .buttonBlue.mtop20 {
    margin-top: 20px; /* no*/
  }
  .loginPage.formStyle .loginForm .pwdTips {
    font-size: 14px; /* no*/
  }
  .loginPage .loginMain {
    padding-top: 50px; /* no*/
  }
  .loginPage .loginLogo2 {
    width: 35%;
    margin: 0 auto 24px auto; /* no*/
  }
  #app .loginPage .button {
    width: 100%;
    margin: 12px 0 16px 0; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue